import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Modal, Fonts } from 'components/base-ui'
import { getSrcSetStr } from 'helpers/image'
import { useTranslation } from 'react-i18next'

const ModalKPromptPayPhoneError = ({ phone, ...rest }) => {
  const { t } = useTranslation()
  return (
    <Modal hideCloseButton={false} {...rest}>
      <ModalContainer>
        <ImgContainer>
          <img
            alt="logo-kplus"
            src={`${process.env.PUBLIC_URL}/assets/generic/modal/promptpay.png`}
            srcSet={getSrcSetStr({
              img: `${process.env.PUBLIC_URL}/assets/generic/modal/promptpay.png`,
              hires2x: true,
              hires3x: true,
            })}
          />
          <ImgMiniWarning
            alt="mini-warning"
            src={`${process.env.PUBLIC_URL}/assets/generic/modal/mini-warning.png`}
            srcSet={getSrcSetStr({
              img: `${process.env.PUBLIC_URL}/assets/generic/modal/mini-warning.png`,
              hires2x: true,
              hires3x: true,
            })}
          />
        </ImgContainer>
        <Fonts.H2 style={{ marginBottom: '14px' }}>{t('modalKPaymentTitle', { phone })}</Fonts.H2>
        <Fonts.Base style={{ marginBottom: '18px' }}>{t('modalKPromptPayPhoneErrorDes')}</Fonts.Base>
      </ModalContainer>
    </Modal>
  )
}

ModalKPromptPayPhoneError.propTypes = {
  onRequestClose: PropTypes.func,
  isOpen: PropTypes.bool,
  phone: PropTypes.string,
}

ModalKPromptPayPhoneError.defaultProps = {
  phone: '',
}

export default ModalKPromptPayPhoneError

const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding-top: 35px;
  padding-bottom: 0;
`

const ImgContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
`

const ImgMiniWarning = styled.img`
  position: absolute;
  left: -8px;
  top: -17px;
`
